import React, { useState, useEffect } from 'react';
import Filter from '../components/Filter';
import {
  getMerk,
  getSeri,
  getTipe,
  getSilinder,
  getTahun,
  getTransmisiCekHarga,
  getKotaCekHarga,
} from '../utils/Filter';
import Axios from 'axios';
import { API_CHECK_PRICE } from '../api/api';
import { Http } from '../constant/Http';
import { Stepper } from 'react-form-stepper';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import {
  clickNextExterior,
  clickNextFrame,
  clickNextInterior,
  clickNextMechanical,
  clickNextVehicle,
} from '../services/amplitude';
import { createNegStatement, createPosStatement } from '../helper';

export const StepCekHarga = () => {
  const [step, setStep] = useState(0);
  const [score, setScore] = useState({
    eksterior1: 0,
    eksterior2: 0,
    eksterior3: 0,
    eksterior4: 0,
    interior1: 0,
    interior2: 0,
    interior3: 0,
    interior4: 0,
    mesin1: 0,
    mesin2: 0,
    mesin3: 0,
    mesin4: 0,
    rangka1: 0,
    rangka2: 0,
  });

  const [filters, setFilters] = useState({
    merk: [],
    seri: [],
    tipe: [],
    silinder: [],
    tahun: [],
    kota: [],
    transmisi: [],
  });

  const dispatch = useDispatch();

  const [selectedValue, setSelected] = useState({
    merk: null,
    seri: null,
    tipe: null,
    silinder: null,
    tahun: null,
    kota: null,
    transmisi: null,
  });

  useEffect(() => {
    getMerk().then((res) => {
      setFilters({ ...filters, merk: res });
    });
  }, []);

  const onChange = (event) => {
    switch (event.target.name) {
      case 'merk':
        getSeri(event.target.value).then((res) => {
          setSelected({ ...selectedValue, merk: event.target.value });
          setFilters({ ...filters, seri: res });
        });
        break;

      case 'seri':
        getTipe(selectedValue.merk, event.target.value).then((res) => {
          setSelected({ ...selectedValue, seri: event.target.value });
          setFilters({ ...filters, tipe: res });
        });
        break;

      case 'tipe':
        getSilinder(selectedValue.merk, selectedValue.seri, event.target.value).then((res) => {
          setSelected({ ...selectedValue, tipe: event.target.value });
          setFilters({ ...filters, silinder: res });
        });
        break;

      case 'silinder':
        getTahun(selectedValue.merk, selectedValue.seri, selectedValue.tipe, event.target.value).then((res) => {
          setSelected({ ...selectedValue, silinder: event.target.value });
          setFilters({ ...filters, tahun: res });
        });
        break;

      case 'tahun':
        getTransmisiCekHarga(
          selectedValue.merk,
          selectedValue.seri,
          selectedValue.tipe,
          selectedValue.silinder,
          event.target.value
        ).then((res) => {
          setSelected({ ...selectedValue, tahun: event.target.value });
          setFilters({ ...filters, transmisi: res });
        });
        break;

      case 'transmisi':
        getKotaCekHarga(
          selectedValue.merk,
          selectedValue.seri,
          selectedValue.tipe,
          selectedValue.silinder,
          selectedValue.tahun,
          event.target.value
        ).then((res) => {
          setSelected({ ...selectedValue, transmisi: event.target.value });
          setFilters({ ...filters, kota: res });
        });
        setSelected({ ...selectedValue, transmisi: event.target.value });
        break;

      case 'kota':
        setSelected({ ...selectedValue, kota: event.target.value });
        break;
    }
  };

  const checkButton = (name) => {
    switch (name) {
      case 'Eksterior':
        if (score.eksterior1 != 0 && score.eksterior2 != 0 && score.eksterior3 != 0 && score.eksterior4 != 0)
          return false;
        else return true;

      case 'Interior':
        if (score.interior1 != 0 && score.interior2 != 0 && score.interior3 != 0 && score.interior4 != 0) return false;
        else return true;

      case 'Mesin':
        if (score.mesin1 != 0 && score.mesin2 != 0 && score.mesin3 != 0 && score.mesin4 != 0) return false;
        else return true;

      case 'Rangka':
        if (score.rangka1 != 0 && score.rangka2 != 0) return false;
        else return true;
    }
  };

  const Score = (event, value) => {
    switch (event.target.name) {
      case 'eksterior-1':
        setScore({ ...score, eksterior1: value });
        break;

      case 'eksterior-2':
        setScore({ ...score, eksterior2: value });
        break;

      case 'eksterior-3':
        setScore({ ...score, eksterior3: value });
        break;

      case 'eksterior-4':
        setScore({ ...score, eksterior4: value });
        break;

      case 'interior-1':
        setScore({ ...score, interior1: value });
        break;

      case 'interior-2':
        setScore({ ...score, interior2: value });
        break;

      case 'interior-3':
        setScore({ ...score, interior3: value });
        break;

      case 'interior-4':
        setScore({ ...score, interior4: value });
        break;

      case 'mesin-1':
        setScore({ ...score, mesin1: value });
        break;

      case 'mesin-2':
        setScore({ ...score, mesin2: value });
        break;

      case 'mesin-3':
        setScore({ ...score, mesin3: value });
        break;

      case 'mesin-4':
        setScore({ ...score, mesin4: value });
        break;

      case 'rangka-1':
        setScore({ ...score, rangka1: value });
        break;

      case 'rangka-2':
        setScore({ ...score, rangka2: value });
        break;
    }
  };

  const history = useHistory();

  const sumValues = (obj) => Object.values(obj).reduce((a, b) => a + b);

  const checkPrice = () => {
    const eksterior_score = score.eksterior1 + score.eksterior2 + score.eksterior3 + score.eksterior4;
    const interior_score = score.interior1 + score.interior2 + score.interior3 + score.interior4;
    const mesin_score = score.mesin1 + score.mesin2 + score.mesin3 + score.mesin4;
    const rangka_score = score.rangka1 + score.rangka2;

    dispatch({ type: 'SET_SELECTED_CEK_HARGA', value: selectedValue });
    dispatch({
      type: 'SET_SCORE',
      value: {
        eksterior: eksterior_score,
        interior: interior_score,
        mesin: mesin_score,
        rangka: rangka_score,
      },
    });

    let data = selectedValue;

    let total = 0;

    for (const [key, value] of Object.entries(score)) {
      total += parseInt(score[key]);
    }

    data.score = total;

    delete data.kota;

    Axios.post(API_CHECK_PRICE.check_price, selectedValue, Http)
      .then((res) => {
        dispatch({ type: 'SET_MAX_MIN', value: res.data.data });
        history.push('/check-price?score=' + total);
      })
      .catch((err) => {});
  };

  const connectorStyle = {
    activeColor: '#82be2a',
    completedColor: '#82be2a',
    size: 5,
  };

  const stepStyle = {
    activeBgColor: '#82be2a',
    completedBgColor: '#82be2a',
  };

  const handleClickNext = (step) => {
    switch (step) {
      case 1:
        setStep(step);
        const { merk, seri, tipe, silinder, tahun, transmisi, kota } = selectedValue;
        clickNextVehicle({
          item_brand: merk,
          item_series: seri,
          item_type: tipe,
          item_cylinder: silinder,
          item_year: tahun,
          item_transmission: transmisi,
          item_city: kota,
        });
        break;
      case 2:
        setStep(step);
        clickNextExterior({
          had_accident: createNegStatement(score.eksterior1),
          is_repaint: createNegStatement(score.eksterior3),
          had_scratch: createNegStatement(score.eksterior2),
          had_dent: createNegStatement(score.eksterior4),
        });
        break;
      case 3:
        setStep(step);
        clickNextInterior({
          is_interior_complete: createPosStatement(score.interior1),
          is_ever_change: createPosStatement(score.interior3),
          is_function_fine: createPosStatement(score.interior2),
          had_scratch: createPosStatement(score.interior4),
        });
        break;
      case 4:
        setStep(step);
        clickNextMechanical({
          is_function_fine: createPosStatement(score.mesin1),
          is_ever_broke: createNegStatement(score.mesin3),
          has_been_flooded: createNegStatement(score.mesin2),
          is_ever_change: createNegStatement(score.mesin4),
        });
        break;
      case 5:
        clickNextFrame({
          is_ever_broke: createNegStatement(score.rangka1),
          is_repair: createNegStatement(score.rangka2),
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 d-lg-block d-md-block d-sm-none">
      <div className="d-flex justify-content-center">
        <Stepper
          connectorStateColors={true}
          styleConfig={stepStyle}
          connectorStyleConfig={connectorStyle}
          steps={[
            { label: 'Kendaraan' },
            { label: 'Eksterior' },
            { label: 'Interior' },
            { label: 'Mesin' },
            { label: 'Rangka' },
          ]}
          activeStep={step}
        />
      </div>
      <div className={step != 0 && 'd-none'}>
        <h6>Data Kendaraan</h6>
        <div className="form-row horizontal">
          <Filter
            disabled={false}
            name="merk"
            options={filters.merk}
            onChange={(event) => {
              onChange(event);
            }}
            label="Merek"
          />
          <Filter
            disabled={selectedValue.merk != null ? false : true}
            options={filters.seri}
            name="seri"
            onChange={(event) => {
              onChange(event);
            }}
            label="Seri"
          />
          <Filter
            disabled={selectedValue.seri != null ? false : true}
            options={filters.tipe}
            name="tipe"
            onChange={(event) => {
              onChange(event);
            }}
            label="Tipe"
          />
          <Filter
            disabled={selectedValue.tipe != null ? false : true}
            options={filters.silinder}
            name="silinder"
            onChange={(event) => {
              onChange(event);
            }}
            label="Silinder"
          />
        </div>
        <div className="form-row mt-1">
          <Filter
            disabled={selectedValue.silinder != null ? false : true}
            options={filters.tahun}
            name="tahun"
            onChange={(event) => {
              onChange(event);
            }}
            label="Tahun"
          />
          <Filter
            disabled={selectedValue.tahun != null ? false : true}
            options={filters.transmisi}
            name="transmisi"
            onChange={(event) => {
              onChange(event);
            }}
            label="Transmisi"
          />
          <Filter
            disabled={selectedValue.transmisi != null ? false : true}
            options={filters.kota}
            name="kota"
            onChange={(event) => {
              onChange(event);
            }}
            label="Kota"
          />
        </div>
        <div className="row mt-4 mb-5">
          <div className="col-md-12 d-flex justify-content-between">
            <button className="btn-overview-green my-2 my-sm-0">Data Tidak Ada</button>
            <button
              disabled={selectedValue.kota == null ? true : false}
              onClick={() => {
                handleClickNext(1);
              }}
              className="btn-overview-green-solid-hovered my-2 my-sm-0"
              type="submit"
              style={{ width: 180 }}
            >
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
      <div className={step != 1 && 'd-none'}>
        <h6>KONDISI EKSTERIOR KENDARAAN</h6>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>
                Apakah kendaraan Anda pernah mengalami kecelakaan ?
              </label>
            </div>
            <RadioGroup name="eksterior-1" row onChange={Score}>
              <FormControlLabel
                value={-10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah bodi kendaraan Anda ada lecet ?</label>
            </div>
            <RadioGroup name="eksterior-2" row onChange={Score}>
              <FormControlLabel
                value={-10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah kendaraan Anda pernah dicat ulang ?</label>
            </div>
            <RadioGroup name="eksterior-3" row onChange={Score}>
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah bodi kendaraan Anda penyok ?</label>
            </div>
            <RadioGroup name="eksterior-4" row onChange={Score}>
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12 d-flex justify-content-between">
            <button
              onClick={() => {
                setStep(0);
              }}
              className="btn-overview-green my-2 my-sm-0"
            >
              Kembali
            </button>
            <button
              disabled={checkButton('Eksterior')}
              onClick={() => {
                handleClickNext(2);
              }}
              className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
              type="submit"
              style={{ width: 180 }}
            >
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
      <div className={step != 2 && 'd-none'}>
        <h6>KONDISI INTERIOR KENDARAAN</h6>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah interior kendaraan Anda lengkap ?</label>
            </div>
            <RadioGroup name="interior-1" row onChange={Score}>
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>
                Apakah fitur interior kendaraan berfungsi dengan baik ?
              </label>
            </div>
            <RadioGroup name="interior-2" row onChange={Score}>
              <FormControlLabel
                value={10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={-10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah interior Anda pernah diganti ?</label>
            </div>
            <RadioGroup name="interior-3" row onChange={Score}>
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah interior kendaraan Anda ada lecet ?</label>
            </div>
            <RadioGroup name="interior-4" row onChange={Score}>
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12 d-flex justify-content-between">
            <button
              onClick={() => {
                setStep(1);
              }}
              className="btn-overview-green my-2 my-sm-0 mr-3"
            >
              Kembali
            </button>
            <button
              disabled={checkButton('Interior')}
              onClick={() => {
                handleClickNext(3);
              }}
              className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
              type="submit"
              style={{ width: 180 }}
            >
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
      <div className={step != 3 && 'd-none'}>
        <h6>KONDISI MESIN KENDARAAN</h6>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>
                Apakah mesin kendaraan Anda berfungsi dengan baik ?
              </label>
            </div>
            <RadioGroup name="mesin-1" row onChange={Score}>
              <FormControlLabel
                value={30}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={-30}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah mesin pernah terendam banjir ?</label>
            </div>
            <RadioGroup name="mesin-2" row onChange={Score}>
              <FormControlLabel
                value={-15}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={15}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah mesin kendaraan Anda pernah mogok ?</label>
            </div>
            <RadioGroup name="mesin-3" row onChange={Score}>
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah mesin kendaraan Anda pernah diganti ?</label>
            </div>
            <RadioGroup name="mesin-4" row onChange={Score}>
              <FormControlLabel
                value={-10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Pernah"
              />
              <FormControlLabel
                value={10}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12 d-flex justify-content-between">
            <button
              onClick={() => {
                setStep(2);
              }}
              className="btn-overview-green my-2 my-sm-0"
            >
              Kembali
            </button>
            <button
              disabled={checkButton('Mesin')}
              onClick={() => {
                handleClickNext(4);
              }}
              className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
              type="submit"
              style={{ width: 180 }}
            >
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
      <div className={step != 4 && 'd-none'}>
        <h6>KONDISI RANGKA KENDARAAN</h6>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah rangka kendaraan Anda ada kerusakan ?</label>
            </div>
            <RadioGroup name="rangka-1" row onChange={Score}>
              <FormControlLabel
                value={-15}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={15}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
          <div className="col-xl-6">
            <div className="form-row mt-4">
              <label style={{ fontSize: 12, fontWeight: 700 }}>Apakah rangka kendaraan Anda ada perbaikan ?</label>
            </div>
            <RadioGroup name="rangka-2" row onChange={Score}>
              <FormControlLabel
                value={-5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Ya"
              />
              <FormControlLabel
                value={5}
                control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#82be2a' } }} />}
                label="Tidak"
              />
            </RadioGroup>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12 d-flex justify-content-between row-rangka">
            <button
              onClick={() => {
                setStep(3);
              }}
              className="btn-overview-green my-2 my-sm-0"
            >
              Kembali
            </button>
            <button
              onClick={() => {
                checkPrice();
                handleClickNext(5);
              }}
              disabled={checkButton('Rangka')}
              className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
              type="submit"
              style={{ width: 180 }}
            >
              Cek Harga
            </button>
          </div>
        </div>
      </div>
      {/* {Step(step)} */}
    </div>
  );
};
